<template>
  <el-dialog :visible.sync="showServiceDialog" :close-on-click-modal="false" :before-close="handleClose" title="选择服务">
    <div>
      <el-tabs v-model="serviceType" @tab-click="handleTabClick">
        <el-tab-pane label="疗管服务" name="2"> </el-tab-pane>
        <el-tab-pane label="医生服务" name="1"> </el-tab-pane>
      </el-tabs>
    </div>
    <div>
      <div style="display:flex">
        <el-input placeholder="请输入服务名称" prefix-icon="el-icon-search" v-model="keyword" size="medium" clearable style="width:300px;margin-bottom:20px"></el-input>
        <div style="margin-left:20px">
          <el-button @click="resetClick" size="medium">重置</el-button>
          <el-button type="primary" @click="getServiceTableData(1)" size="medium">搜索</el-button>
        </div>
      </div>
      <BaseTable :data="tableData" :optimize="true" tooltip-effect="dark" :column="serviceType == '2'?tableConfig1 : tableConfig2" pagination :auto-scroll="true" :total="total" :page.sync="searchParams.current" 
        :limit.sync="searchParams.size" @pagination="getServiceTableData"> </BaseTable>
    </div>
  </el-dialog>
</template>
<script>
import { getTeamServicePage } from "@/api/cooperateChannelManage"
export default {
  props: {
    showServiceDialog: {
      type: Boolean,
      default: false,
    },
    selectConfigItem: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      timer: '',
      keyword: null,
      serviceType: '2',
      searchParams: {
        current: 1,
        size:10
      },
      total: 0,
      tableData: [],
      // tableConfig: [],
      tableConfig1: [ 
        {
          label: "服务名称",
          align: "center",
          prop: "name",
          size: "mini"
        },
        {
          label: "疗管团队",
          align: "center",
          prop: "doctorTeamName" 
        },
        {
          label: "病种",
          align: "center",
          prop: "diseaseType" 
        },
        // {
        //   label: "公共领取",
        //   align: "center",
        //   render: (h, scope) => {
        //     return (
        //       <span slot="reference">
        //         {scope.row.commonStatus ? "是" : "否"}
        //       </span>
        //     );
        //   }
        // }, 
        {
          label: "服务周期",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                { scope.row.period }{ scope.row.periodType }
              </span>
            );
          }
        },
        {
          label: "服务单价",
          align: "center",
          prop: "price", 
        },
        {
          label: "操作",
          align: "center",
          width: "80px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onSelectClick(scope.row);
                    }
                  }
                },
                "选用"
              )
            ]);
          }
        }
      ],

      tableConfig2: [ 
        {
          label: "线下机构",
          align: "center",
          prop: "hospitalName",
          size: "mini"
        },
        {
          label: "医生团队",
          align: "center",
          prop: "doctorTeamName" 
        },
        {
          label: "服务名称",
          align: "center",
          prop: "name",
          size: "mini"
        },
        {
          label: "病种",
          align: "center",
          prop: "diseaseType" 
        },
        // {
        //   label: "公共领取",
        //   align: "center",
        //   render: (h, scope) => {
        //     return (
        //       <span slot="reference">
        //         {scope.row.commonStatus ? "是" : "否"}
        //       </span>
        //     );
        //   }
        // }, 
        {
          label: "服务周期",
          align: "center",
          render: (h, scope) => {
            return (
              <span slot="reference">
                { scope.row.period }{ scope.row.periodType }
              </span>
            );
          }
        },
        {
          label: "服务单价",
          align: "center",
          prop: "price", 
        },
        {
          label: "操作",
          align: "center",
          width: "80px",
          fixed: "right",
          size: "mini",
          render: (h, scope) => {
            return h("div", [
              h(
                "el-button",
                {
                  props: {
                    type: "text",
                    size: "mini"
                  },
                  on: {
                    click: () => {
                      this.onSelectClick(scope.row);
                    }
                  }
                },
                "选用"
              )
            ]);
          }
        }
      ],
    };
  },
  async created() {
    // this.tableConfig = this.tableConfig1
    this.getServiceTableData()
  },
  mounted() {},
  methods: {
    onSelectClick(row) {
      this.$emit('recieveService',this.serviceType,row)
    },
    resetClick() {
      this.keyword = null
      this.getServiceTableData(1)
    },
    handleTabClick() {
      // this.timer = new Date().getTime()
      // this.tableConfig = this.tableConfig2
      this.getServiceTableData(1)
    },
    // isTherapistService 疗管true，医生false
    async getServiceTableData(tag) {
      if (tag == 1) {
        this.searchParams.current = 1
        this.searchParams.size = 10
      }
      let res = await getTeamServicePage({
        current:this.searchParams.current,
        isExperiencePack:false,
        isTherapistService: this.serviceType == '2' ? true : false,
        diseaseId: this.selectConfigItem.diseaseId,
        size:this.searchParams.size,
        keyword:this.keyword,
        searchField:1,
        orderType:1
      })
      if (res.code == 0) {
        this.tableData = res.data.records
        this.total = res.data.total
        console.log(this.tableData)
      }
    },
    handleSelect() {

    },
    handleClose() {
      this.$emit("update:showServiceDialog", false);
    },
  },
};
</script>
<style lang="less" scoped>
</style>